import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilService, ModalScroll, FormValidationsService, SERVICE_END_POINT, AnalyticsService, AuthService } from 'src/app/shared';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import { Subscription, Observable } from 'rxjs';
import * as UserDataConfig from '../../config/user-data.config';
import { ClearToApply } from 'src/app/model/ngrx/clear-to-apply.model';
import * as ClearToApplyActions from '../../../../store/actions/clear-to-apply.actions';
import { ApplicationDataCaptureService } from 'src/app/shared/services/api-services/application-datacapture.service';
import { YourProductApplication } from 'src/app/model/ngrx';
import { PlatformLocation } from '@angular/common';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-submit-application',
  templateUrl: './submit-application.component.html',
  styleUrls: ['./submit-application.component.scss']
})
export class SubmitApplicationComponent implements OnInit {
  contentData;
  CMSData;
  private subscriptn: Subscription;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  public afterApplyDetail = UserDataConfig.ElementsConfig;
  public goToQuoteBTnConfig = this.afterApplyDetail.goBacktoQuoteBtnConfig;
  yourProductApplication: YourProductApplication;



  loggedinDetailsStore: Observable<any[]>;
  public responseApplicationData: any[];
  private responseApplicationDataStore: Observable<any[]>;
  applicationRefrence:string;
  registeredMail:string;
  
  loggedinDetails: any;
  userEmailaddress:string;
  email:String;
  updateVia: string;
  
  constructor(private fb: UntypedFormBuilder, private router: Router,
              private activatedRoute: ActivatedRoute, private store: Store<AppState>,
              private authService: AuthService,
              private utilService: UtilService,
              private applicationDatacaptureService: ApplicationDataCaptureService,
              private platform: PlatformLocation, private analyticsService: AnalyticsService) {
  history.pushState(null, null, location.href);
  platform.onPopState(() => {
      history.go(1);
  });
    this.contentData = this.activatedRoute.snapshot.data.contentData.submitApplication;
    this.loggedinDetailsStore = store.select(STORE_VAL.loggedin_detail);
    this.loggedinDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        
        this.loggedinDetails = val[0];
        this.userEmailaddress=this.loggedinDetails.customer.emailAddress;
      }
    });

    /* fetching application refrence number and user registered mail */
    this.responseApplicationDataStore = this.store.select(STORE_VAL.application_data_response);
    this.responseApplicationDataStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.responseApplicationData = val[0];
        this.applicationRefrence= val[0]['applicationId'];
        this.registeredMail = val[0]['customer']['emailAddress'];        
        this.updateVia = this.responseApplicationData['contactPref'];
        this.analyticsService.orderTrack({ quoteReference : this.responseApplicationData['quoteRefs'][0], applicationReferenceDCJ:this.applicationRefrence});
        
      } else if (val && val.length === 0) {
        this.responseApplicationData = val;
        this.updateVia = this.responseApplicationData['contactPref'];
      }
    });
    /* getting product application values from store */
    store.select(STORE_VAL.your_product_application).subscribe(res => {
      if (res && res.length > 0) {
        this.yourProductApplication = res[0];
      //  this.showViaMail= res[0]["updatesVia"]["email"];
      //  this.showViaText= res[0]["updatesVia"]["text"];
       }
    });

    platform.onPopState(() => {
      // this.applicationDatacaptureService.setBackClicked(true);
      this.router.navigate(['/quote/your-saved-quotes']);
    });
   
  }

  ngOnInit() {
     this.GetCMSDataServiceMapper();
     // tslint:disable-next-line:max-line-length
     this.subscripLogout = this.applicationDatacaptureService.subsVar = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
  }
  saveAfterLogout() {
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  // tslint:disable-next-line:use-life-cycle-interface
  // ngOnDestroy() {
  //   // OnDestroy unsubscribing the subcriptions
  //   if (this.subscriptn) {
  //     this.subscriptn.unsubscribe();
  //   }
  //   if (this.subscripLogout) {
  //     this.subscripLogout.unsubscribe();
  //   }
  // }
  userFormData = () => {
   
  }

  gotoNext = () => {
    /* navigate to saved quote page */
    this.router.navigate(['/quote/your-saved-quotes']);
  }
  
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
  }
  

   /** Code block for CMS */
   GetCMSDataServiceMapper() {

    const URL = SERVICE_END_POINT.higherEnvironment.CMS_AppSubmitted;
    // //console.log('changed value = ', this.contentData.personalDetail.introduction);
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.title = this.CMSData.string_AppEndTitle;
        this.contentData.header = this.CMSData.string_AppEndSubtitle1;
        this.contentData.confirmationEmailInfo = this.CMSData.string_AppEndSubtitle2;
        this.contentData.info = this.CMSData.string_AppEndSubtitle3;
        this.contentData.text1 = this.CMSData.string_AppEndSubtitle6;
        this.contentData.nextHeader = this.CMSData.string_AppEndSubtitle4;
        this.contentData.progressByMail = this.CMSData.string_AppEndSubtitle5 + ' email.';
        this.contentData.progressByText = this.CMSData.string_AppEndSubtitle5 + ' text.';
        this.contentData.text2 = this.CMSData.string_AppEndSubtitle7;
        this.contentData.text3 = this.CMSData.string_AppEndSubtitle8;
      }
    });

  }
  
}
